export default __webpack_public_path__ + "static/media/blur_first.80eb300f.png";